import { gql } from "@apollo/client";

export const SAVE_CONSENTIMIENTO_PACIENTE = gql`
    mutation saveConsentimientoPaciente(
        $consentimientoInput: ArchivoConsentimientoInput!
    ){
        saveConsentimientoPaciente(
            consentimientoInput: $consentimientoInput
        )
    }
`;

export const getParsedConsentimientoInput = (docData, idPaciente, idTipoModulo) => {

  const { contentType,
    titulo,
    archivo,
    extension,
    fechaAlta,
    fechaFirma } = docData;
  return {
    idPaciente,
    idTipoModulo,
    contentType,
    titulo,
    archivo,
    extension,
    fechaAlta,
    fechaFirma
  };
};